import Splide from "@splidejs/splide";

export default class CategoriesSlider {
    constructor() {
        this.everyCategorySlider = [];
        this.categoriesSlider = document.querySelectorAll(
            ".categories-carousel__slider"
        );
        this.events();
    }

    events() {
        window.addEventListener("DOMContentLoaded", () => {
            if (this.categoriesSlider) {
                this.initializeCategoriesSlider();
            }
        });
    }

    initializeCategoriesSlider() {
        this.categoriesSlider.forEach((item) => {
            this.everyCategorySlider.push(
                new Splide(item, {
                    type: "loop",
                    pagination: false,
                    perPage: 7,
                    perMove: 1,
                    gap: 40,
                    arrows: "slider",
                    trimSpace: true,
                    breakpoints: {
                        1280: {
                            arrows: false,
                        },
                        768: {
                            arrows: false,
                            perPage: 4,
                            padding: {
                                right: "5 rem",
                            },
                        },
                        576: {
                            arrows: false,
                            perPage: 2,
                            padding: {
                                right: "2 rem",
                            },
                        },
                    },
                }).mount()
            );
        });
    }
}
